import { useQuery } from 'react-query';

import { queryKeys } from 'src/services/api/constants';
import { apiClient } from 'src/services/api/client';

const PATH = 'api/outlook-integration/get-redirect-url';

type Response = {
    status: string;
    data: string;
};

export const useOutlookRedirectUrl = (enabled?: boolean) => {
    return useQuery(
        [queryKeys.outlookRedirectUrl],
        async () => {
            const res = await apiClient(PATH).json<Response>();
            return res.data;
        },
        { enabled },
    );
};
